import { rootStore } from "./index";

const ROOT_STORE_KEY = "rootStoreKey";
export const saveStoreToLocalStorage = () => {
    try {
        localStorage.setItem(ROOT_STORE_KEY, JSON.stringify(rootStore));
    } catch (err) {
        console.log(err)
    }
};


export const loadFromLocalStorage = (): string => {
    return localStorage.getItem(ROOT_STORE_KEY) || "";
};

export const saveKeyToLocalStorage = (key: string, value: any) => {
    localStorage.setItem(key, value)
}

export const getKeyFromLocalStorage = (key: string) => {
    return localStorage.getItem(key)
}


export const dropLocalState = () => {
    localStorage.removeItem(ROOT_STORE_KEY);
}
